// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.News_wrapper__O-Kr8 {
  position: absolute;
  top: 110px;
  left: 0;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  background: linear-gradient(79.42deg, #47a9f4 1.25%, #0e8eef 82.24%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.News_h2__1--NH {
  font-family: "Lato";
  font-weight: 800;
  letter-spacing: 0px;
  font-size: 24px;
  max-width: 18ch;
  color: white;
  padding-top: 20px;
}

.News_container__l\\+CIo {
  display: flex;
  padding-bottom: 50px;
  gap: 140px;
  margin-left: 13%;
}

.News_left__p3KbB {
  width: 45%;
  display: flex;
}

.News_right__9YOJg {
  width: 40%;
  display: flex;
}

.News_perc__YPOYB {
  background-repeat: no-repeat;
  width: 120px;
  height: 85px;
  margin-top: 35px;
  width: 17%;
  display: flex;
  align-items: center;
}

.News_lefttext__BpZTk {
  width: 85%;
}

.News_dots__c3T8X {
  visibility: hidden;
  position: absolute;
}

@media screen and (max-width: 1400px) {
  .News_container__l\\+CIo {
    margin-left: 80px;
  }
}

@media screen and (max-width: 1300px) {
  .News_container__l\\+CIo {
    margin-left: 50px;
  }
}

@media screen and (max-width: 1200px) {
  .News_container__l\\+CIo {
    margin: 0;
  }
  .News_right__9YOJg {
    width: 100%;
    justify-content: center;
  }
  .News_rightContent__HwE9q {
    width: 45%;
  }
  .News_left__p3KbB {
    width: 97%;
  }
  .News_dots__c3T8X {
    visibility: visible;
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 30px;
  }
  .News_dot1__it2K5 {
    height: 16px;
    width: 16px;
  }
  .News_dot2__hA\\+u3 {
    height: 14px;
    width: 14px;
  }
  .News_hidden__ThPoK {
    position: absolute;
    visibility: hidden;
  }
}

@media screen and (max-width: 500px) {
  .News_perc__YPOYB {
    width: 110px;
  }
  .News_rightContent__HwE9q {
    width: 70%;
  }
  .News_left__p3KbB {
    padding: 0 15px;
    width: 95%;
  }
  .News_wrapper__O-Kr8 {
    min-height: 500px;
    max-height: 500px;
  }
  .News_container__l\\+CIo {
    padding-bottom: 0;
  }
  .News_dots__c3T8X {
    margin-top: 25px;
  }
}

@media screen and (max-width: 410px) {
  .News_percImg__ZtO-4 {
    width: 60px;
    height: 60px;
  }
  .News_perc__YPOYB {
    width: 80px;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/News/News.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,wBAAmB;EAAnB,mBAAmB;EACnB,oEAAoE;EACpE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".wrapper {\n  position: absolute;\n  top: 110px;\n  left: 0;\n  width: 100%;\n  height: fit-content;\n  background: linear-gradient(79.42deg, #47a9f4 1.25%, #0e8eef 82.24%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.h2 {\n  font-family: \"Lato\";\n  font-weight: 800;\n  letter-spacing: 0px;\n  font-size: 24px;\n  max-width: 18ch;\n  color: white;\n  padding-top: 20px;\n}\n\n.container {\n  display: flex;\n  padding-bottom: 50px;\n  gap: 140px;\n  margin-left: 13%;\n}\n\n.left {\n  width: 45%;\n  display: flex;\n}\n\n.right {\n  width: 40%;\n  display: flex;\n}\n\n.perc {\n  background-repeat: no-repeat;\n  width: 120px;\n  height: 85px;\n  margin-top: 35px;\n  width: 17%;\n  display: flex;\n  align-items: center;\n}\n\n.lefttext {\n  width: 85%;\n}\n\n.dots {\n  visibility: hidden;\n  position: absolute;\n}\n\n@media screen and (max-width: 1400px) {\n  .container {\n    margin-left: 80px;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .container {\n    margin-left: 50px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .container {\n    margin: 0;\n  }\n  .right {\n    width: 100%;\n    justify-content: center;\n  }\n  .rightContent {\n    width: 45%;\n  }\n  .left {\n    width: 97%;\n  }\n  .dots {\n    visibility: visible;\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 30px;\n  }\n  .dot1 {\n    height: 16px;\n    width: 16px;\n  }\n  .dot2 {\n    height: 14px;\n    width: 14px;\n  }\n  .hidden {\n    position: absolute;\n    visibility: hidden;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .perc {\n    width: 110px;\n  }\n  .rightContent {\n    width: 70%;\n  }\n  .left {\n    padding: 0 15px;\n    width: 95%;\n  }\n  .wrapper {\n    min-height: 500px;\n    max-height: 500px;\n  }\n  .container {\n    padding-bottom: 0;\n  }\n  .dots {\n    margin-top: 25px;\n  }\n}\n\n@media screen and (max-width: 410px) {\n  .percImg {\n    width: 60px;\n    height: 60px;\n  }\n  .perc {\n    width: 80px;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `News_wrapper__O-Kr8`,
	"h2": `News_h2__1--NH`,
	"container": `News_container__l+CIo`,
	"left": `News_left__p3KbB`,
	"right": `News_right__9YOJg`,
	"perc": `News_perc__YPOYB`,
	"lefttext": `News_lefttext__BpZTk`,
	"dots": `News_dots__c3T8X`,
	"rightContent": `News_rightContent__HwE9q`,
	"dot1": `News_dot1__it2K5`,
	"dot2": `News_dot2__hA+u3`,
	"hidden": `News_hidden__ThPoK`,
	"percImg": `News_percImg__ZtO-4`
};
export default ___CSS_LOADER_EXPORT___;
